import React from 'react';
import styles from './index.module.css';
import logo from '../../images/4bC-logo 1.svg';

import CarouselSection from './components/CarouselSection';
import SignupForm from './components/SignupForm';

const SignupScreen = () => {
  return (
    <div className={styles['signup-container']}>
      <nav className={styles.navbar}>
        <a href="https://4basecare.com/" target="_blank" rel="noreferrer" className={styles['logo-link']}>
          <img src={logo} alt="Logo" className={styles['company-logo']} />
        </a>
      </nav>

      <div className={styles['main-content']}>
        <div className="container-fluid h-100 px-0">
          <div className="row h-100 mx-0">
            <CarouselSection />
            <SignupForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignupScreen;